import React from "react";
import { Pressable } from "native-base";
import { NewButtonBody } from "theme/buttons/new-button-body.component";

export const NewButton = ({
  text,
  iconName,
  onPress,
  textStyles,
  iconStyles,
  fontSize,
  fontWeight,
  isLoading = false,
  rightComponent = undefined,
  ...props
}) => {
  return (
    <Pressable
      p={5}
      {...props}
      onPress={onPress}
      disabled={isLoading}
      _hover={{ bg: "gray.100" }}
      _pressed={{ bg: "gray.100" }}
    >
      <NewButtonBody
        text={text}
        iconName={iconName}
        isLoading={isLoading}
        fontSize={fontSize}
        fontWeight={fontWeight}
        textStyles={textStyles}
        iconStyles={iconStyles}
        rightComponent={rightComponent}
      />
    </Pressable>
  );
};
